import { RATING, TESTIMONIALS } from '@/content/social-proof';
import { useLang, useT } from '@/lib/useLang';

/**
 * Masquée tant que `TESTIMONIALS` est vide. La maquette en affichait trois,
 * signés « Alex R. », « Marie L. » et « Thomas B. » — trois personnes qui
 * n'existent pas, sous une note « 4,9/5 sur 127 avis » qui n'existe pas non
 * plus. Voir `content/social-proof.ts`.
 */
export function Testimonials() {
  const t = useT();
  const lang = useLang();

  if (TESTIMONIALS.length === 0) return null;

  return (
    <section className="nz-testimonials">
      <div className="nz-testimonials__head">
        <div>
          <div className="nz-eyebrow">{t.testiEyebrow}</div>
          <h2 className="nz-h2">{t.testiH2}</h2>
        </div>

        {RATING ? (
          <div className="nz-rating">
            <div className="nz-rating__stars" aria-hidden="true">
              ★★★★★
            </div>
            <div className="nz-rating__count">
              <b>{RATING.score}</b> {t.testiBased.replace('{count}', String(RATING.count))}
              {RATING.source ? ` · ${RATING.source}` : ''}
            </div>
          </div>
        ) : null}
      </div>

      <div className="nz-testimonials__grid">
        {TESTIMONIALS.map((testimonial) => (
          <figure className="nz-testimonial" key={testimonial.name}>
            <div className="nz-testimonial__body">
              {testimonial.stars ? (
                <div
                  className="nz-testimonial__stars"
                  role="img"
                  aria-label={t.testiStars.replace('{count}', String(testimonial.stars))}
                >
                  {'★'.repeat(testimonial.stars)}
                </div>
              ) : null}
              <p>{testimonial.text[lang]}</p>
            </div>
            <figcaption className="nz-testimonial__who">
              {testimonial.avatar ? (
                <img className="nz-testimonial__avatar" src={testimonial.avatar} alt="" loading="lazy" />
              ) : (
                <span className="nz-testimonial__avatar" aria-hidden="true" />
              )}
              <div>
                <div className="nz-testimonial__name">{testimonial.name}</div>
                <div className="nz-testimonial__role">{testimonial.role[lang]}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
